import { StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';

const {
  BORDER_RADIUS, COLOR, ELEVATION, UNIT, SPACE,
} = THEME;

export default StyleSheet.create({
  arrow: {
    borderLeftColor: COLOR.TRANSPARENT,
    borderLeftWidth: SPACE.MEDIUM,
    borderBottomColor: COLOR.WHITE,
    borderBottomWidth: SPACE.S,
    position: 'absolute',
    top: 0,
    right: 0,
    transform: [{ translateY: '-10px' }],
  },

  container: {
    ...ELEVATION.SMALL,
    position: 'absolute',
    top: UNIT * 6.4,
    right: SPACE.S,
    backgroundColor: 'white',
    padding: SPACE.REGULAR,
    borderBottomColor: COLOR.PRIMARY,
    borderBottomWidth: 4,
    minWidth: UNIT * 24,
    width: 'fit-content',
    borderRadius: BORDER_RADIUS,
  },

  title: {
    color: COLOR.LIGHT_GREY,
    marginBottom: SPACE.MEDIUM,
  },
});
